import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, MessageCircle } from "lucide-react";

const contacts = [
  { title: "Telegram-бот Авигатор", subtitle: "Мониторинг Avito в Telegram", url: "https://t.me/avigatr_bot" },
  { title: "Техническая поддержка", subtitle: "Помощь по работе сервиса", url: "https://t.me/pepperchanin" },
];

export const Contacts: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div style={styles.container}>
      <button style={styles.backBtn} onClick={() => navigate("/info")}>
        <ArrowLeft size={16} /> Информация
      </button>
      <h1 style={styles.title}>Контакты</h1>
      <div style={styles.list}>
        {contacts.map((c) => (
          <a key={c.url} href={c.url} target="_blank" rel="noopener noreferrer" style={styles.card}>
            <div style={styles.cardIcon}>
              <MessageCircle size={20} />
            </div>
            <div>
              <div style={styles.cardTitle}>{c.title}</div>
              <div style={styles.cardSubtitle}>{c.subtitle}</div>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  container: { padding: "16px", maxWidth: "480px", margin: "0 auto" },
  backBtn: { display: "flex", alignItems: "center", gap: "6px", background: "none", border: "none", color: "var(--tg-theme-link-color, #2481cc)", fontSize: "14px", cursor: "pointer", padding: 0, marginBottom: "12px" },
  title: { fontSize: "20px", fontWeight: 700, margin: "0 0 16px 0", color: "var(--tg-theme-text-color, #000)" },
  list: { display: "flex", flexDirection: "column", gap: "10px" },
  card: { display: "flex", alignItems: "center", gap: "12px", padding: "14px", backgroundColor: "var(--tg-theme-secondary-bg-color, #fff)", borderRadius: "14px", textDecoration: "none", boxShadow: "0 1px 3px rgba(0,0,0,0.08)" },
  cardIcon: { width: "40px", height: "40px", borderRadius: "10px", backgroundColor: "var(--tg-theme-button-color, #2481cc)20", color: "var(--tg-theme-button-color, #2481cc)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 },
  cardTitle: { fontSize: "15px", fontWeight: 600, color: "var(--tg-theme-text-color, #000)" },
  cardSubtitle: { fontSize: "12px", color: "var(--tg-theme-hint-color, #666)", marginTop: "2px" },
};
